import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroContent } from './IntroContent';
import { KeyHighlights } from './KeyHighlights';
import { RegistrationCallout } from './RegistrationCallout';
import { VideoSection } from './VideoSection';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function SelfDefensePage() {
  return <PageLayout data-id="element-3212">
      <HeaderBanner data-id="element-3213" />
      <IntroContent data-id="element-3214" />
      <KeyHighlights data-id="element-3215" />
      <RegistrationCallout data-id="element-3216" />
      <VideoSection data-id="element-3217" />
      <ContactSection data-id="element-3218" />
      <QuickLinks data-id="element-3219" />
    </PageLayout>;
}